import { ApiNotification } from "utils/api/notifications";
import {
  ACCOUNT_SETUP_STATES,
  CARDHOLDER_STATES,
} from "utils/constants/onboarding";
import { ApiUserProfile } from "utils/api/user";
import { formatCurrency } from "utils/string";
import creditCardIcon from "assets/images/icon/credit-card.svg";
import { NotificationMessageProps, NotificationUi } from "../../types";

const getEarnedWageAccessOnboardingTitle = ({
  notification,
}: NotificationMessageProps) => {
  const { state } = notification.params;
  if (ACCOUNT_SETUP_STATES.includes(state)) {
    return "Finish setting up your account";
  }

  return "Continue your Reset card application";
};

const getEarnedWageAccessOnboardingMessage = ({
  notification,
  dashboardOverview,
}: NotificationMessageProps) => {
  const { state } = notification.params;
  if (ACCOUNT_SETUP_STATES.includes(state)) {
    return "Get daily access to your income as you earn it!";
  }

  const { currentAmount, maxAmount } = dashboardOverview?.dsl || {};

  if (maxAmount > currentAmount || currentAmount === 0) {
    return "Get daily access to your income as you earn it!";
  }

  return `You're almost there! Access your ${formatCurrency(currentAmount, true)} spending limit in minutes.`;
};

const EARNED_WAGE_ACCESS_ONBOARDING_NOTIFICATION: NotificationUi = {
  title: getEarnedWageAccessOnboardingTitle,
  message: getEarnedWageAccessOnboardingMessage,
  customIcon: creditCardIcon,
};

const EARNED_WAGE_ACCESS_APPLICATION_STATUS_NOTIFICATION: NotificationUi = {
  title: () => "Your Reset card application is in progress",
  message: () => "Click here to see your application status.",
  customIcon: creditCardIcon,
};

export const getEarnedWageAccessOnboardingNotification = ({
  notification,
  userProfile,
}: {
  notification: ApiNotification;
  userProfile: ApiUserProfile;
}) => {
  if (CARDHOLDER_STATES.includes(notification.params.state)) return undefined;

  // There are some cases where the notification data may indicate no action is required, but the user may still need to take action, e.g. after initially submitting IDV
  if (!notification.requireAction)
    return EARNED_WAGE_ACCESS_APPLICATION_STATUS_NOTIFICATION;

  if (
    !ACCOUNT_SETUP_STATES.includes(notification.params.state) &&
    !userProfile?.eligibleForCard
  )
    return undefined;

  return EARNED_WAGE_ACCESS_ONBOARDING_NOTIFICATION;
};
